import { TranslateService } from "@ngx-translate/core";

export function translateServiceSet(translate: TranslateService) {
  translate.use(localStorage.getItem("locale"));
  translate.setTranslation(
    localStorage.getItem("locale"),
    JSON.parse(localStorage.getItem("translation"))
  );
}
